export default "__VITE_ASSET__LulKGN0c__"